<template>
		<div v-bind:class="{active: active}" class="q-mark" @mouseover="onMouseover" @mouseleave="onMouseleave" @click="openPopup">
			<span>?</span>
			<div class="q-mark-popup">
				<slot></slot>
			</div>
		</div>
</template>

<script>
	export default {
	data() {
		return {
			active: false,
			timeoutId: null
		}
	},
	methods: {
		onMouseover() {
			this.timeoutId = setTimeout(() => {
				this.active = true;
				this.timeoutId = null;
			}, 700);
		},
		onMouseleave() {
			if (this.timeoutId) {
				clearTimeout(this.timeoutId);
				this.timeoutId = null;
			}
			this.active = false;
		},
		openPopup(event) {
			this.active = !this.active;
			this.$root.$emit("showPopup", this.active);
			event.preventDefault();
		}
	} 
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/QMark.vue